'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _date_formatter = require('../../../packages/common-utilities/src/date_formatter.js');

var _date_formatter2 = _interopRequireDefault(_date_formatter);

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _collection_utility = require('common-utilities/src/collection_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LipperRatings = function (_React$Component) {
  _inherits(LipperRatings, _React$Component);

  function LipperRatings(props) {
    _classCallCheck(this, LipperRatings);

    return _possibleConstructorReturn(this, (LipperRatings.__proto__ || Object.getPrototypeOf(LipperRatings)).call(this, props));
  }

  _createClass(LipperRatings, [{
    key: 'getLipperRatingInfo',
    value: function getLipperRatingInfo(infoType) {
      return _collection_utility.CollectionUtility.find(this.props.lipperRating, function (obj) {
        return obj.periodIndicator === infoType;
      });
    }
  }, {
    key: 'getRankNumber',
    value: function getRankNumber(infoType) {
      var info = this.getLipperRatingInfo(infoType);
      if ((0, _ramda.isNil)(info)) {
        return null;
      } else {
        return info.rankNumber;
      }
    }
  }, {
    key: 'getGroupPercentile',
    value: function getGroupPercentile(infoType) {
      var info = this.getLipperRatingInfo(infoType);
      if ((0, _ramda.isNil)(info)) {
        return null;
      } else {
        return info.groupPercentile;
      }
    }
  }, {
    key: 'getPercentileRatings',
    value: function getPercentileRatings(rankPercentile) {
      if (!(0, _ramda.isNil)(rankPercentile)) {
        return rankPercentile + "%";
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'body1' },
          '-'
        );
      }
    }
  }, {
    key: 'getPeerGroupCount',
    value: function getPeerGroupCount(infoType) {
      var info = this.getLipperRatingInfo(infoType);
      if ((0, _ramda.isNil)(info)) {
        return null;
      } else {
        return info.peerGroupCount;
      }
    }
  }, {
    key: 'getFormatedRankNumber',
    value: function getFormatedRankNumber(rankNumber) {
      if ((0, _ramda.isNil)(rankNumber)) {
        return _react2.default.createElement(
          'div',
          { className: 'body1' },
          '-'
        );
      } else {
        return "Rank " + rankNumber;
      }
    }
  }, {
    key: 'getFormatedPeerGroupCount',
    value: function getFormatedPeerGroupCount(peerGroupCount) {
      if ((0, _ramda.isNil)(peerGroupCount)) {
        return "-";
      } else {
        return peerGroupCount + " Funds in Category";
      }
    }
  }, {
    key: 'getTextAlign',
    value: function getTextAlign(breakpoint, isDisclaimer) {
      if (breakpoint > 3) {
        return 'text-left ' + (!isDisclaimer ? "width-percent-25" : "");
      } else {
        return "text-center";
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { 'data-testid': 'lipper-ratings-card' },
        _react2.default.createElement(
          _card_component2.default,
          {
            headerTitle: 'Lipper Rankings: ' + this.props.peerGroupCategory,
            headerTitleId: "fund-ratings-lipper-header",
            headerTitleLabel: "fund-ratings-lipper-header",
            headerLabel: _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-lipper-effective-date',
                className: 'margin-top--25 ' + (this.props.breakpoint < 3 ? "display-inline padding-horizontal-16" : "float-right text-right") + ' disclaimer2' },
              ' As of ',
              _date_formatter2.default.getDateInSlashFormatOrNA(this.props.lipperRatingEffectiveDate)
            ),
            disclosureText: this.props.disclosure,
            breakpoint: this.props.breakpoint,
            placementId: "pdpCardLipperRankings"
          },
          _react2.default.createElement(
            'div',
            { className: 'row margin-horizontal-0' },
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-lipper-1yr-rank-count-div', className: "col-md-3 col-xs-6 col-sm-6 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                '1 Year'
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-1yr-group-percentile' },
                this.getPercentileRatings(this.getGroupPercentile('1YR'))
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-1yr-rank-count' },
                this.getFormatedRankNumber(this.getRankNumber('1YR'))
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-lipper-1yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('1YR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-lipper-3yr-rank-count-div', className: "col-md-3 col-xs-6 col-sm-6 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                '3 Year'
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-3yr-group-percentile' },
                this.getPercentileRatings(this.getGroupPercentile('3YR'))
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-3yr-rank-count' },
                this.getFormatedRankNumber(this.getRankNumber('3YR'))
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-lipper-3yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('3YR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-lipper-5yr-rank-count-div', className: "col-md-3 col-xs-6 col-sm-6 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                '5 Year'
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-5yr-group-percentile' },
                this.getPercentileRatings(this.getGroupPercentile('5YR'))
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-5yr-rank-count' },
                this.getFormatedRankNumber(this.getRankNumber('5YR'))
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-lipper-5yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('5YR'))
              )
            ),
            _react2.default.createElement(
              'div',
              { 'data-testid': 'fund-ratings-lipper-10yr-rank-count-div', className: "col-md-3 col-xs-6 col-sm-6 margin-horizontal-0 margin-vertical-5 ratings-card-section " + this.getTextAlign(this.props.breakpoint) },
              _react2.default.createElement(
                'span',
                { className: 'title sub-header-3' },
                '10 Year'
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-10yr-group-percentile' },
                this.getPercentileRatings(this.getGroupPercentile('10Y'))
              ),
              _react2.default.createElement(
                'div',
                { 'data-testid': 'fund-ratings-lipper-10yr-rank-count' },
                this.getFormatedRankNumber(this.getRankNumber('10Y'))
              ),
              _react2.default.createElement(
                'div',
                { className: "disclaimer2 margin-top-10 " + this.getTextAlign(this.props.breakpoint, true), 'data-testid': 'fund-ratings-lipper-10yr-group-count' },
                this.getFormatedPeerGroupCount(this.getPeerGroupCount('10Y'))
              )
            )
          )
        )
      );
    }
  }]);

  return LipperRatings;
}(_react2.default.Component);

exports.default = LipperRatings;